// Note - this file is only consumed when the vite-auto-translate-plugin
// is not engaged. If it is engaged, things are redirected to the ./production.ts
// this exists to explain types & and have basic functionality for TSC and other
// tools.

export const Namespaces = [] as string[];
export const LocaleMapping = {} as Record<string, Record<string, string>>;

export * from "./at";
export * from "./autotranslate";
export * from "./SkipTranslate";
